import { TableConfig } from '@shared/interfaces/table/table-config';
import { EstimationGroupMeteringPointSearchResult } from '@app/api/dmc';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';

export const estimationGroupMeteringPointTable: TableConfig<EstimationGroupMeteringPointSearchResult> = {
  selectable: true,
  columns: [
    {
      title: 'meteringpoint.table.id',
      key: 'meteringPointIdentification'
    },
    {
      title: 'vee.meteringpoint.address',
      key: 'meteringPointAdress',
    },
    settlementmethodPartial,
    meteringPointTypePartial,
    {
      title: 'vee.meteringpoint.consumption',
      key: 'estimatedAnnualVolume',
    },
    {
      title: 'vee.meteringpoint.estimationGroupName',
      key: 'estimationGroupName',
    }
  ]
}
